'use client';

import React from 'react';

export const useIsMounted = (): boolean => {
  const isMountedRef = React.useRef(false);
  React.useEffect(() => {
    isMountedRef.current = true;
  }, []);
  return isMountedRef.current;
};
